module.exports = __webpack_public_path__ + "img/course2.0e8ee2ec.jpg";